import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";
import { IResponse } from "../interfaces/response";

const getProductNotficationsTypes = async () => {
  const { data } = await getData(`${ajaxEndpoints.PRODUCT_NOTIFICATION_TYPES}`);
  return data;
};

export default function useProductNotificationsTypes() {
  return useQuery<IResponse<{ id: number; name: string }[]>>(
    ["getProductNotficationsTypes"],
    getProductNotficationsTypes,
    {
      refetchOnWindowFocus: false,
    }
  );
}
